import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ecc94b",
      "fill-rule": "evenodd",
      d: "M3.9 4.7c-.5 0-1 .4-1 .9v12.7c0 .5.5 1 1 1H22c.4 0 .8-.5.8-1v-9L13 14 3 9.3v-2l10 4.8 10-4.7V5.6c0-.5-.4-.9-.8-.9z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }